export const ProductDetailsConstants = {
    GET_PRODUCTDETAILS: 'GET_PRODUCTDETAILS',

    GET_PRODUCTDETAILS_REQUEST: 'GET_PRODUCTDETAILS_REQUEST',
    GET_PRODUCTDETAILS_SUCCESS: 'GET_PRODUCTDETAILS_SUCCESS',
    GET_PRODUCTDETAILS_FAILURE: 'GET_PRODUCTDETAILS_FAILURE'
};
